import { Navigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext"; // 1. Import our custom hook

import InactiveUserQuiz from "../screens/InactiveUserQuiz";


export default function PrivateRoute({ children }) {
  // 2. Get the user and loading state from our global context
  const { user, loading } = useAppContext();
  const getAccountStatusType = (accountStatus) => {
    if (accountStatus === undefined || accountStatus === null) return "unknown";
    if (typeof accountStatus === "boolean") return accountStatus ? "active" : "inactive";
    if (typeof accountStatus === "number") {
      if (accountStatus === 1) return "active";
      if (accountStatus === 0) return "inactive";
      return "unknown";
    }
    if (typeof accountStatus === "string") {
      const normalized = accountStatus.trim().toLowerCase();
      if (normalized === "true" || normalized === "1" || normalized === "active") return "active";
      if (normalized === "false" || normalized === "0" || normalized === "inactive") return "inactive";
      return "unknown";
    }
    return "unknown";
  };
  
  // 3. While the context is doing its initial check for a user, show a loading screen.
  // This is the most important step. It pauses rendering until the app knows
  // for sure whether a user is logged in or not.
  if (loading) {
    return (
      <div className="mainhome-screen-wrapper">
        <div style={{ margin: 'auto', color: '#333' }}>Loading...</div>
      </div>
    );
  }

  // 4. After the check is complete, if there IS a user object, show the protected page.
  if (user) {
    const accountStatusType = getAccountStatusType(user.accountStatus);

    // Don't render protected screen until account status is clearly known.
    if (accountStatusType === "unknown") {
      return (
        <div className="mainhome-screen-wrapper">
          <div style={{ margin: "auto", color: "#333" }}>Loading...</div>
        </div>
      );
    }

    if (accountStatusType === "inactive") {
      return <InactiveUserQuiz />;
    }
    return children;
  }


  // 5. If the check is complete and there is NO user, redirect to the login screen.
  return <Navigate to="/enter-mobile" replace />;
}
